import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { MessageCircle, Phone, Mail } from "lucide-react";
import { trackEvent, getSessionId } from "@/lib/tracking";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Client-side tracked redirect to WhatsApp / Email / Phone.
// Always redirects even if tracking is blocked → contact never fails.
const OutRedirect = () => {
  const { channel } = useParams();
  useEffect(() => {
    const eventMap = {
      whatsapp: "click_whatsapp",
      email: "click_email",
      telefon: "click_phone",
    };
    const ev = eventMap[channel];
    if (ev) {
      try { trackEvent(ev, { channel }); } catch { /* ignore */ }
    }
    // Fire redirect via backend endpoint (server-side log too) after brief tick
    const url = `${BACKEND_URL}/api/out/${channel}?session_id=${encodeURIComponent(getSessionId())}`;
    const t = setTimeout(() => { window.location.replace(url); }, 120);
    // Safety fallback: if backend blocked, hard-redirect
    const safe = setTimeout(() => {
      const fallbacks = {
        whatsapp: "https://wa.me/4917684211137?text=Hallo%20Tobias%2C%20ich%20interessiere%20mich%20f%C3%BCr%20dein%20Coaching.",
        email: "mailto:mail@tobinunner.de",
        telefon: "tel:+4917684211137",
      };
      if (fallbacks[channel]) window.location.replace(fallbacks[channel]);
    }, 1500);
    return () => { clearTimeout(t); clearTimeout(safe); };
  }, [channel]);

  const icons = { whatsapp: <MessageCircle size={24}/>, email: <Mail size={24}/>, telefon: <Phone size={24}/> };
  return (
    <div className="min-h-screen bg-[#5C6B49] text-[#F3F1E8] flex items-center justify-center px-4" data-testid="out-redirect">
      <div className="text-center">
        <div className="w-14 h-14 rounded-full bg-[#E8E5D0]/15 border border-[#E8E5D0]/30 mx-auto flex items-center justify-center mb-4">
          {icons[channel] || icons.whatsapp}
        </div>
        <div className="text-sm text-[#C9C6B4]">Verbindung wird hergestellt…</div>
      </div>
    </div>
  );
};

export default OutRedirect;
